import { store } from '../redux';

export const isAuthenticated = () => {
   const state = store.getState();
   return state.UserReducer.auth;
}